export default __webpack_public_path__ + "static/media/promo-ice-breaker-bot.9c28089d.png";